export default class TextSimplifier {
  constructor() {
    this.isActive = false;
    this.puterLoaded = false;
    this.clickHandler = this.handleClick.bind(this);
    this.hoverHandler = this.handleHover.bind(this);
  }

  async enable() {
    this.isActive = true;
    document.addEventListener('click', this.clickHandler, true);
    document.addEventListener('mouseover', this.hoverHandler, true);
    document.body.classList.add('a11y-text-simplifier-active');
  }

  disable() {
    this.isActive = false;
    document.removeEventListener('click', this.clickHandler, true);
    document.removeEventListener('mouseover', this.hoverHandler, true);
    document.body.classList.remove('a11y-text-simplifier-active'); 
    this.removeHighlights();
  }

  async loadPuter() {
    if (window.puter) {
      this.puterLoaded = true;
      return;
    }
    
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.puter.com/v2/';
        script.onload = () => {
            this.puterLoaded = true;
            resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });
  }

  handleHover(event) {
      if (!this.isActive) return;
      const target = event.target;
      // Target text blocks
      const textBlock = target.closest('p, h1, h2, h3, h4, h5, h6, li, span, div');
      
      this.removeHighlights();
      
      if (textBlock && textBlock.innerText.trim().length > 20) { // Only plausible text
          textBlock.classList.add('a11y-simplifier-hover');
      }
  }

  removeHighlights() {
      document.querySelectorAll('.a11y-simplifier-hover').forEach(el => el.classList.remove('a11y-simplifier-hover'));
  }

  async handleClick(event) {
    if (!this.isActive) return;
    
    // Ignore clicks on sidebar, tutorial modal, or system elements
    if (event.target.closest('.a11y-sidebar') || 
        event.target.closest('.a11y-tutorial-modal') ||
        event.target.closest('.a11y-tts-toolbar')) return;

    const target = event.target.closest('p, h1, h2, h3, h4, h5, h6, li, span, div');

    if (!target || target.innerText.trim().length < 5) return;

    // Prevent default
    event.preventDefault();
    event.stopPropagation();

    // Check if already simplified
    if (target.dataset.originalText) {
        // Revert
        target.innerHTML = target.dataset.originalText;
        delete target.dataset.originalText;
        return;
    }

    this.simplifyText(target);
  }

  async simplifyText(target) {
    const originalText = target.innerText;
    const originalHTML = target.innerHTML;
    
    // Save original for revert
    target.dataset.originalText = originalHTML;

    // Loading State
    const originalCursor = document.body.style.cursor;
    document.body.style.cursor = 'wait';
    target.style.opacity = '0.5';

    try {
        if (!this.puterLoaded) await this.loadPuter();

        const prompt = `Wyjaśnij o czym jest poniższy tekst. Napisz krótkie podsumowanie/wyjaśnienie prostym językiem (Easy-to-Read). Twoja odpowiedź zastąpi ten tekst, więc nie używaj wstępów typu "Ten tekst jest o...". Po prostu napisz wyjaśnienie:\n\n"${originalText}"`;

        // Use a faster model if possible, explicit instruction
        const response = await window.puter.ai.chat(prompt, { model: 'gpt-4o-mini' });
        
        console.log("AI Response:", response); // Debugging

        // Parse Response (Handle string or Object)
        let simplified = '';
        if (typeof response === 'string') {
            simplified = response;
        } else if (response && response.message && response.message.content) {
             simplified = response.message.content;
        } else if (response && response.result && response.result.message && response.result.message.content) {
             simplified = response.result.message.content; // Based on user log
        }

        if (simplified) {
            // Apply simplified text
            target.innerHTML = `<span class="a11y-simplified-text" title="Kliknij, aby przywrócić oryginał">${simplified}</span>`;
            
            // Add visual cue
            target.style.borderLeft = '4px solid #4ade80'; // Green indicator
            target.style.paddingLeft = '8px';
        }

    } catch (e) {
        console.error("Simplifier Error:", e);
        // Revert on error
        target.innerHTML = originalHTML;
        delete target.dataset.originalText;
        // alert("Nie udało się uprościć tekstu."); // Remove alert to be less annoying
    } finally {
        document.body.style.cursor = originalCursor;
        target.style.opacity = '1';
    }
  }
}
